<template>
  <div :class="['', attrs.class]">
    <label 
      v-if="label" 
      :for="inputId" 
      class="block text-sm text-neutral-850 mb-2"
    >
      {{ label }}
    </label>
    <input 
      :id="inputId"
      :type="type"
      :placeholder="placeholder"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :class="`w-full px-3 py-2 border ${disabled ? 'bg-gray-100' : ''} ${error ? 'border-red-500' : 'border-neutral-100'} rounded-md-custom text-sm focus:outline-none focus:border-primary-500`"
      :disabled="disabled"
    />
    <p v-if="error" class="text-red-500 text-sm mt-1">{{ error }}</p>
  </div>
</template>

<script setup>
import { computed, useAttrs } from 'vue';


defineOptions({ inheritAttrs: false });

const attrs = useAttrs();

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  label: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: 'text'
  },
  disabled: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: ''
  },
  error: {
    type: String,
    default: ''
  },
  id: {
    type: String,
    default: ''
  }
});

defineEmits(['update:modelValue']);

const inputId = computed(() => {
  return props.id || `input-${Math.random().toString(36).substr(2, 9)}`;
});
</script>

